export function ReplyButton({ onReply }) {
    return (
      <button
        onClick={onReply}
        className="absolute bottom-2 right-8 p-1 text-gray-500 hover:text-blue-500 transition-colors"
        title="Reply to message"
        aria-label="Reply to message"
      >
        <span className="text-lg">↩️</span>
      </button>
    );
  }